module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div style=\"max-width: 700px;\">\n    <div class=\"ctrl-psel-filter\">\n        <input type=\"text\" placeholder=\"Поиск значения...\">\n    </div>\n    <div class=\"ctrl-psel-grid\" style=\"margin-top: 10px;\"></div>\n</div>\n")
  }
  return __output.join("");

}